export enum SourceType {
  PUSH = 'Push',
  PULL = 'Pull'
}
